export const EMBED_FIGMA_CONFIG = {
    name        : 'Figma',
    icon        : 'i5-figma',
    iconSvg     : 'isvg-figma',
    description : 'Embeded figma',
    embedCode   : '',
    projectIcon : 'figma',                  // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['figma.com']             // required for embedCode content search for autodetect EmbedType
}
